module.exports = __webpack_public_path__ + "static/media/overviewanim.24e3857c.gif";